import {Component, type ReactNode} from 'react'

type MapErrorBoundaryProps = {
    children: ReactNode
    fallback: ReactNode
    onError?: (error: Error) => void
}

type MapErrorBoundaryState = {
    hasError: boolean
}

/** Contains Maps runtime failures so the surrounding workflow remains available. */
export class MapErrorBoundary extends Component<MapErrorBoundaryProps, MapErrorBoundaryState> {
    override state: MapErrorBoundaryState = {hasError: false}

    static getDerivedStateFromError(): MapErrorBoundaryState {
        return {hasError: true}
    }

    override componentDidCatch(error: Error) {
        this.props.onError?.(error)
    }

    override render() {
        return this.state.hasError ? this.props.fallback : this.props.children
    }
}
